import PlaneCard from '../Common/PlaneCard';
import { useLang } from '@/i18n';

export default function SectionBrackets() {
    const { t } = useLang('theProduct.SectionBrackets');

    return (
        <PlaneCard
            title={t('title')}
            desc={t('desc')}
            pc="https://websiteoss.ecoflow.com/upload/image/1748331011922/bracket.jpg"
            h5="https://websiteoss.ecoflow.com/upload/image/1748331016837/bracket_h5.jpg"
        />
    );
}
